import { defineMessages } from "react-intl";

import {
	encephalopathyGradeMessages,
	hasOccurredMessages,
	validator
} from "lib/build/forms/ltx/phase-i/medical-history/liver-related-complications/encephalopathy";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	encephalopathy: {
		id: "form.encephalopathy",
		defaultMessage: "Encephalopathia"
	},
	hasOccurred: {
		id: "form.encephalopathy.hasOccurred",
		defaultMessage: "Fordult-e elő a betegnél encephalopathia?"
	},
	encephalopathyGrade: {
		id: "form.encephalopathy.encephalopathyGrade",
		defaultMessage: "Encephalopathia fokozata"
	}
});

const fields: { [key: string]: FieldData } = {
	hasOccurred: {
		type: "field",
		path: ["hasOccurred"],
		label: messages.hasOccurred,
		errorMessages: genericErrorMessages,
		input: { type: "button-group", props: { labels: hasOccurredMessages } }
	},
	encephalopathyGrade: {
		type: "field",
		path: ["encephalopathyGrade"],
		label: messages.encephalopathyGrade,
		errorMessages: genericErrorMessages,
		input: {
			type: "button-group",
			props: { labels: encephalopathyGradeMessages }
		}
	}
};

const fieldset: FieldsetData = {
	rows: [
		{ columns: [{ width: 12, field: fields.hasOccurred }] },
		{ columns: [{ width: 12, field: fields.encephalopathyGrade }] }
	]
};

export const node: LeafNode = {
	id: "encephalopathy",
	value: {
		title: messages.encephalopathy,
		validator,
		fieldset,
		isImportant: false
	}
};
